// write me a plugin to run vue extension via vue.use
import VueApexCharts from "vue3-apexcharts";
import { defineNuxtPlugin } from '#app'
// import ApexCharts from 'apexcharts';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueApexCharts)
//   nuxtApp.provide('apexcharts', apexcharts)
})
